/*****************************************************************************************************************************************************
 * Revision History
 * 2024-01-22 TBH - Changed excelArrayData to use ReferenceId (as "DCE ID#") rather than StudentId (as "StudentId").
 *****************************************************************************************************************************************************/
export default function instructorClassRoster() {
// console.log( 'instructorClassRoster' );
  return {
    activeStudents: [],
    reservedStudents: [],
    droppedStudents: [],
    waitListStudents: [],
    fethedAcademicYear: '',
    fethedAcademicTerm: '',
    fethedAcademicSession: '',
    fethedSerialId: '',
    fetchedEventId: '',
    fetchedTitle: '',
    fetchedSection: '',
    fetchedFee: '',
    fetchedAdds: '',
    fetchedMax: '',
    fetchedDisplayAttandenceSheet: false,
    fetchedFinalGradeReceived: false,
    fetchedStartDate: '',
    fetchedEndDate: '',
    fetchedPercentage: '',
    fetchedActiveStudentCount: 0,
    fetchedReservedStudentCount: 0,
    fetchedDroppedStudentCount: 0,
    fetchedWaitListStudentCount: 0,
    fetchedCourseMeetings:[],
    studentData: '',
    isSuccessMessage: false,
    isEmailSuccessMessage: false,
    message: '',
    emailMessage: '',
    excelArrayData: [],
    showLabel : true,
    reportTitle : 'Meetings_Report',

    formatDate( dateValue ) {
      const options = { month: 'short', day: 'numeric', year: 'numeric' };
      const formattedDate = new Date( dateValue ).toLocaleDateString( undefined, options );
      return formattedDate;
    },
    formatValue( value ) {
    // Convert value to 0.00 format
      return parseFloat( value ).toFixed( 2 );
    },
    formatMeetingDate( dateValue ) {
      const date = new Date( dateValue );
      const month = date.getMonth() + 1; // Month is zero-based, so add 1
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    },
    formatEventId( eventId ) {
      if( eventId != null ) {
        return eventId.replace( "_", " " );
      }
    },
    bindClassRoster() {
// console.log( 'bindClassRoster()' );
      fetch( '/api/Instructors/GetClassRosters', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          AcademicYear: document.getElementById( "academicYear" ).value,
          AcademicTerm: document.getElementById( "academicTerm" ).value,
          SerialId: document.getElementById( "serialId" ).value,
        })
      }).then( response => {
        if( response.ok ) {
          return response.json()
        }
      }).then( response => {
        if( response.isSuccess ) {
          this.activeStudents= response.activeStudents;
          this.reservedStudents= response.reservedStudents;
          this.droppedStudents = response.droppedStudents;
          this.waitListStudents = response.waitListStudents;
          this.fethedAcademicYear = response.academicYear;
          this.fethedAcademicTerm = response.academicTerm;
          this.fethedAcademicSession = response.academicSession;
          this.fethedSerialId = response.serialId;
          this.fetchedEventId = response.eventId;
          this.fetchedTitle = response.title;
          this.fetchedSection = response.section;
          this.fetchedFee = response.fee;
          this.fetchedAdds = response.adds;
          this.fetchedMax = response.max;
          this.fetchedDisplayAttandenceSheet = response.displayAttandenceSheet;
          this.fetchedFinalGradeReceived = response.finalGradeReceived;
          this.fetchedStartDate = response.startDate;
          this.fetchedEndDate = response.endDate;
          this.fetchedPercentage = response.percentage;
          this.fetchedActiveStudentCount = response.activeStudentCount;
          this.fetchedReservedStudentCount = response.reservedStudentCount;
          this.fetchedDroppedStudentCount = response.droppedStudentCount;
          this.fetchedWaitListStudentCount = response.waitListStudentCount; 

          if( this.fetchedDisplayAttandenceSheet ) {
            fetch( '/api/ProgramAPI/GetCourseMeetings', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                AcademicYear:document.getElementById( "academicYear" ).value,
                AcademicTerm:document.getElementById( "academicTerm" ).value,
                SerialId: document.getElementById( "serialId" ).value,
              })
            }).then( response => {
              if( response.ok ) {
                return response.json()
              }
            }).then( response => {
              if( response.isSuccess ) {
                this.fetchedCourseMeetings = response.courseMeetings;
                this.createExcelArray();
                this.isSuccessMessage = true;
              } else {
                this.isSuccessMessage = false;
                this.message = "An unknown error has occurred. Please try again later."
              }
            });
          }
        } else {
          this.isSuccessMessage = false;
          this.message = "An unknown error has occurred. Please try again later."
        }
      });

    },

    createExcelArray() {
// console.log( "createExcelArray()" );
// console.log( "activeStudents: " + JSON.stringify( this.activeStudents ));
      this.excelArrayData = this.activeStudents.map( student => {
        // Combine each student with courseMeeting using a loop
        const newStudent = {
          "DCE ID#": student.referenceId,
          "First Name": student.firstName,
          "Last Name": student.lastName
        };
// console.log( "excelArrayData: " + JSON.stringify( this.excelArrayData ));

        for( let i = 0; i < this.fetchedCourseMeetings.length; i++ ) {
          const meetingDateKey = this.formatMeetingDate( this.fetchedCourseMeetings[i]?.meetingDate );
          newStudent[ meetingDateKey ] = '';
        }
// console.log( "newStudent: " + JSON.stringify( newStudent ));
      return( newStudent );
      });
    },

    downloadFile() {
      let text = JSON.stringify( this.excelArrayData );
      let filename = 'student.json';
      let element = document.createElement( 'a' );
      element.setAttribute( 'href', 'data:application/json;charset=utf-8,' + encodeURIComponent( text ));
      element.setAttribute( 'download', filename );
      element.click();
    },

    JSONToCSVConvertor() {
      var arrData = typeof JSON.stringify( this.excelArrayData ) !== 'object' 
          ? JSON.parse( JSON.stringify( this.excelArrayData )) 
          : JSON.stringify( this.excelArrayData );
      var CSV = '';

      // This condition will generate the Label/Header
      if( this.showLabel ) {
        var row = "";
        for( var index in arrData[ 0 ] ) {
          row += index + ',';
        }

        row = row.slice( 0, -1 );
        CSV += row + '\r\n';
      }

      for( var i = 0; i < arrData.length; i++ ) {
        var row = "";
        for( var index in arrData[ i ] ) {
          row += '"' + arrData[ i ][ index ] + '",';
        }

        row.slice( 0, row.length - 1 );
        CSV += row + '\r\n';
      }

      if( CSV === '' ) {
        alert( "Invalid data" );
        return;
      }

      // Generate a file name
      var fileName = this.reportTitle + '-' + this.fethedAcademicYear + '-' + this.fethedAcademicTerm + '-' + this.fethedSerialId
// console.log( "CVS Filename: " + filename );
      var uri = 'data:text/csv;charset=utf-8,' +  encodeURIComponent( CSV );
// console.log( "CVS uri: " + uri );

      var link = document.createElement( "a" );
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";

      document.body.appendChild( link );
      link.click();
      document.body.removeChild( link );
    },

    printAttendanceData() {
      var content = '<div style="text-align:center;"><h2>Attendance Sheet</h2></div>';
      content += '<table border="1" style="margin: auto;">';

      // Add table headers
      content += '<tr>';
      for( var key in this.excelArrayData[ 0 ] ) {
        content += '<th>' + key + '</th>';
      }
      content += '</tr>';

      // Add table data rows
      for( var i = 0; i < this.excelArrayData.length; i++ ) {
        content += '<tr>';
        for( var key in this.excelArrayData[i] ) {
          content += '<td>' + this.excelArrayData[i][key] + '</td>';
        }
        content += '</tr>';
      }

      content += '</table>';

      // Open a new window with the content
      var printWindow = window.open( '', '_blank' );
      printWindow.document.open();
      printWindow.document.write( '<html><head><title>Attendance Sheet</title></head><body>' + content + '</body></html>' );
      printWindow.document.close();

      // Initiate the print dialog for the new window
      printWindow.print();
      printWindow.close();
    },

    SendStudentsMissingFromRosterEmail() {
      if( this.studentData == "" || this.studentData == null ) {
        this.isEmailSuccessMessage = false;
        this.emailMessage = "Please enter student details."
      } else {
        fetch( '/api/Instructors/SendStudentsMissingFromRosterEmail', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            FromEmail: document.getElementById( "Email" ).value,
            StudentData: this.studentData,
            AcademicYear: document.getElementById( "academicYear" ).value,
            AcademicTerm: document.getElementById( "academicTerm" ).value,
            SerialId: document.getElementById( "serialId" ).value
          })
        }).then( response => {
          if( response.ok ) {
            return response.json()
          }
        }).then( response => {
          if( response.isSuccess ) {
            this.isEmailSuccessMessage = true;
            this.emailMessage = "Email sent."
            this.studentData = "";
          } else {
            this.isEmailSuccessMessage = false;
            this.emailMessage = "An unknown error has occurred. Please try again later."
          }
        });
      }
    },
       
    init() {
      this.bindClassRoster();
    }
  }
}